import {Component, Input, OnDestroy} from '@angular/core';
import {ExecutorModel} from '../../models/executor.model';
import {employeeExtendedRegistrationStatusType} from '../../../utility/extended-registration-status-type';
import {ImmutableListRepositoryService} from '../../../../lib/gelios-field/immutable-list-repository.service';
import {timestampToDate} from '../../../utility/timestamp-functions';
import {RouteLibraryEntities, RouteLibraryEntity} from '../../../route/route-library-entity';
import {RouteLibraryService} from '../../../route/route-library.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-executor-employee-info',
  templateUrl: './executor-employee-info.component.html',
  styleUrls: ['./executor-employee-info.component.scss'],
})
export class ExecutorEmployeeInfoComponent implements OnDestroy {
  @Input() model: ExecutorModel;
  subscriptions: Subscription[] = [];
  routeEntity: RouteLibraryEntity;
  protected readonly RouteLibraryEntities = RouteLibraryEntities;
  protected readonly timestampToDate = timestampToDate;
  protected readonly employeeExtendedRegistrationStatusType = employeeExtendedRegistrationStatusType;

  constructor(
    protected immutableList: ImmutableListRepositoryService,
    public routeLibrary: RouteLibraryService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.subscriptions.push(
      this.activatedRoute.data.subscribe(data => {
        this.routeEntity = data.routeEntity;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(v => v.unsubscribe());
  }
}
